import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import * as React from 'react';

import Dialog from 'components/Dialog';
import Image from 'components/Image';
import Link from 'components/Link';
import VideoEmbed from 'components/VideoEmbed';
import { ReactComponent as ArrowUpRight } from 'images/icons/arrow_up_right.svg';
import zparse from 'utils/zparse';

const BlogCard = ({ intro, photo, uri, title, cta = 'READ MORE', type = 'blog', className = '', imageWidth, imageHeight, videoEmbed }) => {
	const [isOpen, setIsOpen] = React.useState(false);
	const [dialogTitle, setDialogTitle] = React.useState('');
	const [dialogContent, setDialogContent] = React.useState('');

	const handleClose = () => {
		setIsOpen(false);
		setTimeout(() => setDialogContent(''), 500);
	}

	const handleVideo = (title, embed) => {
		setDialogTitle(title);
		setDialogContent(<VideoEmbed embed={embed}/>);
	}

	React.useEffect(() => {
		if (dialogContent)setIsOpen(true);
	}, [dialogContent]);

	if (!uri && !videoEmbed) return null;

	const introText = (intro || '').trim();

	const isContentless = !title && !introText;

	return (
		<>
		<Box className={`BlogCard-root ${className}  ${isContentless ? 'contentless' : ''} ${(type === 'textCard') ? 'no-media' : ''}`.trim()}>
			{type !== 'textCard' && <Link href={uri} onClick={videoEmbed ? () => handleVideo(title, videoEmbed) : null} className="BlogCard-mediaLink" aria-label={title}>
				<Box className="BlogCard-media">
					{photo ? (
						<Image
							src={photo}
							alt={title || ''}
							layout={Image.COVER}
							width={imageWidth ?? 600}
							height={imageHeight ?? 223}
							classPrefix="BlogCardImage"
						/>
					) : (
						<Box className="BlogCard-mediaFallback" aria-hidden="true" />
					)}
				</Box>
			</Link>}

			{(title || introText) && (
				<Box className="BlogCard-content">
					{(title && <Typography component="div" variant={(type === 'textCard' || type === 'resourceCard') ? 'h3' : 'h5'} className="BlogCard-title">
							<Link href={uri}>{title}</Link>
						</Typography>
					)}
					{introText && (
						<Typography component="div" variant="body1" className="BlogCard-intro">
							{zparse(introText)}
						</Typography>
					)}
				</Box>
			)}

			<Link href={uri} onClick={videoEmbed ? () => handleVideo(title, videoEmbed) : null} className="BlogCard-ctaBar" aria-label={`${cta}: ${title}`}>
				<Box className="BlogCard-cta">
					<Typography component="span" className="BlogCard-ctaText">
						{cta}
					</Typography>
					<Typography component="span" className="BlogCard-ctaIcon" aria-hidden="true">
						<ArrowUpRight />
					</Typography>
				</Box>
			</Link>
		</Box>
		<Dialog open={isOpen} onClose={handleClose} title={dialogTitle}>
			{dialogContent}
		</Dialog>
		</>
	);
};

export default React.memo(BlogCard);
